import React from 'react';
import { Coffee, Heart, Star } from 'lucide-react';

interface FallbackAdProps {
  size: 'desktop' | 'mobile';
  className?: string;
}

export const FallbackAd: React.FC<FallbackAdProps> = ({ 
  size, 
  className = '' 
}) => {
  const isDesktop = size === 'desktop';
  
  if (isDesktop) {
    return (
      <div className={`bg-gradient-to-br from-blue-50 to-indigo-50 dark:from-blue-900/20 dark:to-indigo-900/20 border border-blue-200 dark:border-blue-800 rounded-lg p-4 ${className}`}>
        <div className="text-center">
          <div className="flex justify-center mb-2">
            <div className="flex items-center gap-1 text-blue-600 dark:text-blue-400">
              <Coffee className="w-4 h-4" />
              <span className="text-sm font-medium">Support Us</span>
            </div>
          </div>
          <p className="text-xs text-gray-600 dark:text-gray-400 mb-2">
            Help keep Spinner Games free
          </p>
          <div className="flex justify-center gap-1 mb-2">
            {[...Array(5)].map((_, i) => (
              <Star key={i} className="w-3 h-3 text-yellow-400 fill-current" />
            ))}
          </div>
          <p className="text-xs text-gray-500 dark:text-gray-500">
            Consider whitelisting our site
          </p>
        </div>
      </div>
    );
  }

  // Mobile fallback
  return (
    <div className={`bg-gradient-to-r from-blue-50 to-indigo-50 dark:from-blue-900/20 dark:to-indigo-900/20 border-t border-blue-200 dark:border-blue-800 p-3 ${className}`}>
      <div className="flex items-center justify-center gap-2">
        <Heart className="w-4 h-4 text-red-500" />
        <span className="text-sm text-blue-600 dark:text-blue-400 font-medium">
          Support Spinner Games
        </span>
        <Coffee className="w-4 h-4 text-blue-600 dark:text-blue-400" />
      </div>
      <p className="text-xs text-center text-gray-600 dark:text-gray-400 mt-1">
        Help keep our service free by whitelisting our site
      </p>
    </div>
  );
};

export default FallbackAd;
